import i18n from "@/i18n";

const routes = {
  path: "/sale",
  name: "Sale",
  component: () =>
    import(/* webpackChunkName: "tournament" */ "@/views/sale/Main"),
  children: [
    {
      path: "fittingsalelist/:goodstype?",
      alias: "",
      name: "FittingSaleList",
      component: () =>
        import(
          /* webpackChunkName: "tournament" */ "@/views/sale/FittingSaleList"
        ),
      prop: true,
      meta: {
        location: "/sale/fittingsalelist",
        layout: "DefaultLayout",
        wrapId: "sub",
        subtitle: i18n.t("menu.sales.sales"),
        menu_num: 6,
        sub_menu_num: 61,
        step: [
          i18n.t("menu.sales.sales"),
          /* i18n.t("page.sales.sales_list"), */
        ],
      },
    },
    {
      path: "fittingsaleview/:fittinganswerno",

      name: "FittingSaleView",
      component: () =>
        import(
          /* webpackChunkName: "tournament" */ "@/views/sale/FittingSaleView"
        ),
      prop: true,
      meta: {
        location: "/sale/fittingsalelist",
        layout: "DefaultLayout",
        wrapId: "sub",
        subtitle: i18n.t("page.sales.sales_information"),
        menu_num: 6,
        sub_menu_num: 62,
        step: [
          i18n.t("menu.sales.sales"),
          /* i18n.t("page.sales.sales_information"), */
        ],
      },
    },
    // {
    //   path: "fittingshippingview/:ship_pk",
    //   name: "FittingShippingView",
    //   component: () =>
    //     import(
    //       /* webpackChunkName: "tournament" */ "@/views/sale/FittingShippingView"
    //     ),
    //   prop: true,
    //   meta: {
    //     layout: "DefaultLayout",
    //     wrapId: "sub",
    //     subtitle: "판매 배송 보기",
    //     menu_num: 6,
    //     sub_menu_num: 62,
    //     step: ["판매", "판매 배송 보기"],
    //   },
    // },
    // {
    //   path: "fittingshippingwrite",
    //   name: "FittingShippingWrite",
    //   component: () =>
    //     import(
    //       /* webpackChunkName: "tournament" */ "@/views/sale/FittingShippingWrite"
    //     ),
    //   prop: true,
    //   meta: {
    //     layout: "DefaultLayout",
    //     wrapId: "sub",
    //     subtitle: "판매 배송 등록",
    //     menu_num: 6,
    //     sub_menu_num: 63,
    //     step: ["판매", "판매 배송 등록"],
    //   },
    // },
  ],
};

export default routes;
